import React from 'react';
import { ArrowDown } from 'lucide-react';
const withoutSteps = ['Book creates trust', 'Generic next step', 'Unknown reader', 'Unknown outcome'];
const withSteps = ['Book creates trust', 'Reader finds what applies', 'Takes a useful next move', 'Raises a hand with context', 'Moves toward fitting support'];
function Node({
  label,
  active
}: {
  label: string;
  active: boolean;
}) {
  return <div className={`w-full rounded-xl border px-5 py-4 text-center text-sm md:text-base ${active ? 'border-seaglass bg-white font-medium text-navy shadow-sm' : 'border-gray-200 bg-white/70 text-text-muted'}`} data-id="element-752" data-mp="282nq0egpzi7x">
      {label}
    </div>;
}
function Connector({
  active
}: {
  active: boolean;
}) {
  return <div className="flex justify-center py-1.5" data-id="element-753" data-mp="1u2w5rvzm15lh">
      <ArrowDown className={`h-4 w-4 ${active ? 'text-seaglass' : 'text-gray-300'}`} aria-hidden="true" data-id="element-754" data-mp="1u24lvifdkwb1" />
    </div>;
}

/** Diagram 1 — without / with Reader-to-Revenue System. */
export function GapDiagram() {
  return <div className="grid gap-6 md:grid-cols-2 md:gap-8" data-id="element-755" data-mp="ipk8y529pn8t">
      <div className="flex h-full flex-col rounded-3xl border border-gray-200 bg-paper p-7 md:p-8" data-id="element-756" data-mp="3eip41emi838">
        <span className="mb-6 inline-flex w-fit rounded-full border border-gray-200 bg-white px-4 py-1.5 text-xs font-bold uppercase tracking-[0.16em] text-text-muted" data-id="element-757" data-mp="7dhs3ggsnus1">
          Without a Reader-to-Revenue System
        </span>
        <div className="flex flex-1 flex-col justify-start" data-id="element-758" data-mp="3ullh2v2aciei">
          {withoutSteps.map((step, i) => <React.Fragment key={step} data-id="element-759" data-mp="3ftb87u77r48k" data-mpi={i}>
              <Node label={step} active={false} data-id="element-760" data-mp="3kl2rrkryc9p7" />
              {i < withoutSteps.length - 1 && <Connector active={false} data-id="element-761" data-mp="36twjaz6p31q6" />}
            </React.Fragment>)}
        </div>
      </div>

      <div className="flex h-full flex-col rounded-3xl border-2 border-seaglass bg-white p-7 shadow-[0_24px_50px_-28px_rgba(139,168,159,0.7)] md:p-8" data-id="element-762" data-mp="36s3cnjw30hi6">
        <span className="mb-6 inline-flex w-fit rounded-full bg-seaglass px-4 py-1.5 text-xs font-bold uppercase tracking-[0.16em] text-white" data-id="element-763" data-mp="2wx1lyjm5r7dh">
          With a Reader-to-Revenue System
        </span>
        <div className="flex flex-1 flex-col justify-start" data-id="element-764" data-mp="2iqzwqevcru48">
          {withSteps.map((step, i) => <React.Fragment key={step} data-id="element-765" data-mp="2dygjxk4hp30h" data-mpi={i}>
              <Node label={step} active={true} data-id="element-766" data-mp="2dxexyklxqw3z" />
              {i < withSteps.length - 1 && <Connector active={true} data-id="element-767" data-mp="290wt7kqluxrn" />}
            </React.Fragment>)}
        </div>
      </div>
    </div>;
}